export default "__VITE_ASSET__kgoKdHkF__"